var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 331,
    viewBox: "0 0 655 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_449389_1218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.589 105.07C324.824 104.404 324.351 103.482 324.346 102.466L324.345 72.779C324.345 65.8005 328.058 59.2218 334.288 55.1906C345.404 47.9768 349.254 35.2068 343.646 24.1232C338.462 13.9623 325.583 7.61822 312.979 9.06627C303.358 10.1749 295.22 15.0032 290.634 22.3105C286.646 28.6903 280.343 33.8364 272.893 36.8052C270.765 37.649 268.265 36.8366 267.291 34.9876C266.322 33.1336 267.255 30.9458 269.384 30.102C275.094 27.8262 280.135 23.7062 283.214 18.7844C289.097 9.38901 299.543 3.18601 311.866 1.76384C328.124 -0.106119 344.734 8.04013 351.371 21.1643C358.575 35.4089 353.631 51.8307 339.334 61.106C335.244 63.752 332.799 68.1214 332.799 72.7778L332.799 102.464C332.799 104.496 330.904 106.146 328.572 106.146C327.4 106.148 326.348 105.732 325.589 105.07Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6184 303.31V318.041H627.528V303.31H29.6184Z",
    fill: "#F5C294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.156 133.897C258.393 149.726 244.175 162.288 227.086 170.277L67.063 245.062C64.1504 246.422 62.3515 249.145 62.6563 252.005C63.0982 256.151 60.8263 260.339 56.4196 262.562C52.2222 264.687 47.223 264.458 43.3848 262.364C40.2339 260.65 36.1497 261.176 33.3877 263.343C19.3241 274.385 9.70954 289.301 6.56503 305.915C5.56094 311.217 4.80719 316.551 4.26908 321.894C3.65319 327.993 11.3967 332.061 17.3039 328.749L328.567 154.455L328.567 95.5283C299.514 95.5332 274.735 111.492 265.156 133.897Z",
    fill: "#DFAE82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.816 322.009C652.26 316.004 651.429 310.019 650.233 304.071C647.04 288.145 637.491 273.962 623.876 263.364C620.982 261.114 616.851 260.838 613.502 262.546C609.669 264.499 604.779 264.645 600.683 262.536C596.33 260.296 594.1 256.145 594.531 252.041C594.835 249.171 593.048 246.437 590.136 245.078L430.059 170.267C412.976 162.282 398.758 149.72 391.995 133.892C382.416 111.486 357.638 95.5283 328.579 95.5283L328.579 154.454L639.8 328.723C645.647 332.004 653.378 328.051 652.816 322.009Z",
    fill: "#DFAE82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_449389_1218",
    x: 0,
    y: 0,
    width: 659,
    height: 335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_449389_1218"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger);
export default __webpack_public_path__ + "static/media/hanger.e6fb9902077ef5f57a9c0b0af265a7c6.svg";
export { ForwardRef as ReactComponent };